import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { useDownloadValidation } from '../../hooks/useFiles';
import {
    Box,
    Button,
    IconButton,
} from '@mui/material';

function StaticValidationView({handleCloseValidationView}){
    const file = useSelector((state) => state.FileReducer.file);
    const [results, setResults] = React.useState(file.file);
    const [summary, setSummary] = React.useState(file.summary);
    const [fileName, setFileName] = React.useState(file.info.name);
    const companyId = useSelector((state) => state.CompanyReducer.userCompanies[0]);
    const downloadValidation = useDownloadValidation();

    const handleDownload = () => {
        downloadValidation.mutate(file.info);
    };

    React.useEffect(() => {
        setResults(file.file);
        setSummary(file.summary);
        setFileName(file.info.name);
    }, [file.file]);

    return(
    <div>
        <Box m={2} sx={{  display: 'flex', flexDirection:'column', justifyContent: 'center', height: '100%', minHeight: '300px'}}>
            <IconButton
                edge="start"
                color="inherit"
                onClick={()=> handleCloseValidationView()}
                aria-label="close"
            >
                <CloseIcon />
            </IconButton>
            <h4 style={{}}>{file.info.name}</h4>
            {file.info.isProcessed == 3 ?
                <div>
                    <p>
                        File and Estimate have been accepted, the file validation report is being updated. 
                        <br/> 
                        <br/> 
                        Please wait a few minutes for the process to complete and then view the updated validation report.
                    </p>
                </div>
            :
                <div>
                    <Button autoFocus style={{width:'50%', alignSelf:'center' }} onClick={handleDownload} variant="outlined">Download</Button>    
                    <Box m={2} sx={{  display: 'flex', flexDirection:'row', justifyContent: 'center',height: '100%', minHeight: '300px'}}>
                        <div style={{flex:2, margin: 20, overflowX:'scroll'}}>
                            <h4 style={{textAlign:'left'}}>Validation:</h4>
                            <pre style={{textAlign:'left'}}>
                                {results}
                            </pre>
                        </div>
                        <div style={{flex:1, margin:20}}>
                            <h4 style={{textAlign:'left'}}>Summary:</h4>
                                <pre style={{textAlign:'left'}}>
                                    {summary}
                                </pre>
                        </div>
                    </Box> 
                </div>
            }
        </Box> 
    </div>
    )
};

export default StaticValidationView;